import { ApiError } from '@lib/api/api-response';

import { isApiError } from './is-api-error';

/** Type guard: true when the error is an ApiError with a 4xx status code (client errors should not be retried). */
export function isNonRetryableError(error: unknown): error is ApiError {
  return isApiError(error) && error.status >= 400 && error.status < 500;
}
